import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableFormGroup = ({ iError, iTouched, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('cuentaContable', salida.value)
      setFieldValue('cuentaContableInfo', salida.label)
      setFieldValue('flagCentroCosto', salida.flagCentroCosto)
      setFieldValue('esCuentaActivoFijo', salida.tipoDocumento === 'A')

      if (!salida.value.startsWith('3') && !salida.value.startsWith('6') && !salida.value.startsWith('9') && !salida.value.startsWith('7')) {
        setFieldValue('tipoAfectacion', '')
      }

      KeyEventUtil.leaveOnKeyEvent('modal-select-tipoAfectacion')
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContable', '')
    setFieldValue('cuentaContableInfo', '')
    setFieldValue('_idCentroCosto', '')
    setFieldValue('centroCostoInfo', '')
    setFieldValue('centroCostoRepartos', [])
    setFieldValue('flagCentroCosto', false)
    setFieldValue('esCuentaActivoFijo', false)

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent('modal-select-cuentaContable')
    }, 200)
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='CUENTA CONTABLE' htmlFor='modal-select-cuentaContable' md={12} />
      <Col md={12}>
        {iValue ? (
          <ClearInputGroup id='cuentaContable' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='modal-select-cuentaContable' onlyAnalitica onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
